<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7780_7776)">
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="#F5BFAE"
      />
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="url(#paint0_radial_7780_7776)"
      />
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="url(#paint1_linear_7780_7776)"
      />
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="url(#paint2_radial_7780_7776)"
      />
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="url(#paint3_radial_7780_7776)"
      />
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="url(#paint4_radial_7780_7776)"
      />
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="url(#paint5_radial_7780_7776)"
      />
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="url(#paint6_radial_7780_7776)"
      />
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="url(#paint7_radial_7780_7776)"
      />
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="url(#paint8_radial_7780_7776)"
      />
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="url(#paint9_radial_7780_7776)"
      />
      <path
        d="M19.1452 6.19922C20.1007 6.19922 20.9064 6.84067 21.1551 7.71642C21.9549 10.0388 23.4052 13.3449 24.4821 14.8394C24.6728 14.3467 24.8108 13.7299 24.871 13.1876C24.8919 12.9995 25.0235 11.7774 25.2072 11.2313C25.4285 10.5731 25.8849 10.0069 26.571 9.78525C27.6876 9.42459 28.9008 10.0858 29.2808 11.2621C29.3158 11.3706 29.3425 11.4796 29.3613 11.5884C29.4918 12.1475 29.4013 12.6613 29.3476 13.0001C29.2643 13.5261 29.0757 14.7876 28.9882 15.6251C28.8789 16.672 28.8164 18.4298 29.1132 20.4063C29.4132 21.8188 29.332 23.3178 29.2539 23.8907C28.3933 30.2014 21.4063 30.672 19.4413 29.7412C18.1025 29.3061 16.6826 28.2709 14.7304 26.2735C12.4479 23.9382 10.363 21.3679 9.20227 19.63C8.94 19.2835 8.78442 18.8518 8.78442 18.3838C8.78442 17.2423 9.70981 16.3169 10.8513 16.3169C11.0699 16.3169 11.2806 16.3508 11.4784 16.4137C11.1016 15.6794 10.7976 15.0374 10.5607 14.3272C10.4882 14.1164 10.4488 13.8901 10.4488 13.6547C10.4488 12.5132 11.3742 11.5878 12.5157 11.5878C13.1488 11.5878 13.7154 11.8724 14.0945 12.3206C13.9749 12.0532 13.26 10.2882 13.1347 9.46564C13.1191 9.36334 13.1111 9.25859 13.1111 9.15195C13.1111 8.01044 14.0364 7.08505 15.1779 7.08505C16.011 7.08505 16.729 7.57794 17.0562 8.28802C17.0563 7.13438 17.9916 6.19922 19.1452 6.19922Z"
        fill="url(#paint10_radial_7780_7776)"
      />
      <path
        d="M17.0562 8.26289C17.0847 8.51084 17.1578 8.829 17.3074 9.21883C17.3725 9.38865 17.4518 9.60627 17.5451 9.86198C17.9638 11.0889 18.751 13.1699 19.7948 15.0719C20.1881 15.7885 20.9056 16.2917 21.7222 16.2535C22.798 16.2033 24.0341 15.8483 24.5077 14.7891L24.5049 14.779C24.4973 14.7993 24.4897 14.8195 24.482 14.8394C23.405 13.3449 21.9548 10.0388 21.1549 7.71642C20.9062 6.84067 20.1006 6.19922 19.1451 6.19922C17.9998 6.19922 17.0698 7.12083 17.0562 8.26289Z"
        fill="url(#paint11_radial_7780_7776)"
      />
      <path
        d="M17.0562 8.26289C17.0847 8.51084 17.1578 8.829 17.3074 9.21883C17.3725 9.38865 17.4518 9.60627 17.5451 9.86198C17.9638 11.0889 18.751 13.1699 19.7948 15.0719C20.1881 15.7885 20.9056 16.2917 21.7222 16.2535C22.798 16.2033 24.0341 15.8483 24.5077 14.7891L24.5049 14.779C24.4973 14.7993 24.4897 14.8195 24.482 14.8394C23.405 13.3449 21.9548 10.0388 21.1549 7.71642C20.9062 6.84067 20.1006 6.19922 19.1451 6.19922C17.9998 6.19922 17.0698 7.12083 17.0562 8.26289Z"
        fill="url(#paint12_radial_7780_7776)"
      />
      <path
        d="M17.0562 8.26289C17.0847 8.51084 17.1578 8.829 17.3074 9.21883C17.3725 9.38865 17.4518 9.60627 17.5451 9.86198C17.9638 11.0889 18.751 13.1699 19.7948 15.0719C20.1881 15.7885 20.9056 16.2917 21.7222 16.2535C22.798 16.2033 24.0341 15.8483 24.5077 14.7891L24.5049 14.779C24.4973 14.7993 24.4897 14.8195 24.482 14.8394C23.405 13.3449 21.9548 10.0388 21.1549 7.71642C20.9062 6.84067 20.1006 6.19922 19.1451 6.19922C17.9998 6.19922 17.0698 7.12083 17.0562 8.26289Z"
        fill="url(#paint13_radial_7780_7776)"
      />
      <path
        d="M17.0562 8.26289C17.0847 8.51084 17.1578 8.829 17.3074 9.21883C17.3725 9.38865 17.4518 9.60627 17.5451 9.86198C17.9638 11.0889 18.751 13.1699 19.7948 15.0719C20.1881 15.7885 20.9056 16.2917 21.7222 16.2535C22.798 16.2033 24.0341 15.8483 24.5077 14.7891L24.5049 14.779C24.4973 14.7993 24.4897 14.8195 24.482 14.8394C23.405 13.3449 21.9548 10.0388 21.1549 7.71642C20.9062 6.84067 20.1006 6.19922 19.1451 6.19922C17.9998 6.19922 17.0698 7.12083 17.0562 8.26289Z"
        fill="url(#paint14_radial_7780_7776)"
      />
      <path
        d="M17.0562 8.26289C17.0847 8.51084 17.1578 8.829 17.3074 9.21883C17.3725 9.38865 17.4518 9.60627 17.5451 9.86198C17.9638 11.0889 18.751 13.1699 19.7948 15.0719C20.1881 15.7885 20.9056 16.2917 21.7222 16.2535C22.798 16.2033 24.0341 15.8483 24.5077 14.7891L24.5049 14.779C24.4973 14.7993 24.4897 14.8195 24.482 14.8394C23.405 13.3449 21.9548 10.0388 21.1549 7.71642C20.9062 6.84067 20.1006 6.19922 19.1451 6.19922C17.9998 6.19922 17.0698 7.12083 17.0562 8.26289Z"
        fill="url(#paint15_radial_7780_7776)"
      />
      <path
        d="M17.0562 8.26289C17.0847 8.51084 17.1578 8.829 17.3074 9.21883C17.3725 9.38865 17.4518 9.60627 17.5451 9.86198C17.9638 11.0889 18.751 13.1699 19.7948 15.0719C20.1881 15.7885 20.9056 16.2917 21.7222 16.2535C22.798 16.2033 24.0341 15.8483 24.5077 14.7891L24.5049 14.779C24.4973 14.7993 24.4897 14.8195 24.482 14.8394C23.405 13.3449 21.9548 10.0388 21.1549 7.71642C20.9062 6.84067 20.1006 6.19922 19.1451 6.19922C17.9998 6.19922 17.0698 7.12083 17.0562 8.26289Z"
        fill="url(#paint16_radial_7780_7776)"
      />
      <path
        d="M17.0562 8.26289C17.0847 8.51084 17.1578 8.829 17.3074 9.21883C17.3725 9.38865 17.4518 9.60627 17.5451 9.86198C17.9638 11.0889 18.751 13.1699 19.7948 15.0719C20.1881 15.7885 20.9056 16.2917 21.7222 16.2535C22.798 16.2033 24.0341 15.8483 24.5077 14.7891L24.5049 14.779C24.4973 14.7993 24.4897 14.8195 24.482 14.8394C23.405 13.3449 21.9548 10.0388 21.1549 7.71642C20.9062 6.84067 20.1006 6.19922 19.1451 6.19922C17.9998 6.19922 17.0698 7.12083 17.0562 8.26289Z"
        fill="url(#paint17_radial_7780_7776)"
      />
      <path
        d="M17.0562 8.26289C17.0847 8.51084 17.1578 8.829 17.3074 9.21883C17.3725 9.38865 17.4518 9.60627 17.5451 9.86198C17.9638 11.0889 18.751 13.1699 19.7948 15.0719C20.1881 15.7885 20.9056 16.2917 21.7222 16.2535C22.798 16.2033 24.0341 15.8483 24.5077 14.7891L24.5049 14.779C24.4973 14.7993 24.4897 14.8195 24.482 14.8394C23.405 13.3449 21.9548 10.0388 21.1549 7.71642C20.9062 6.84067 20.1006 6.19922 19.1451 6.19922C17.9998 6.19922 17.0698 7.12083 17.0562 8.26289Z"
        fill="url(#paint18_linear_7780_7776)"
      />
      <path
        d="M10.5645 14.3273C10.492 14.1165 10.4526 13.8902 10.4526 13.6548C10.4526 12.5133 11.378 11.5879 12.5195 11.5879C13.1417 11.5879 13.6996 11.8628 14.0785 12.2977C15.1132 14.383 16.3875 16.8158 17.3554 18.2346C16.125 19.9064 15.8294 20.7502 15.5742 21.4689C14.7929 20.3804 13.1585 18.1644 12.5742 17.4221C12.261 17.0242 11.8789 16.5158 11.4844 16.4143C11.0703 15.6525 10.7696 14.9423 10.5645 14.3273Z"
        fill="url(#paint19_radial_7780_7776)"
      />
      <path
        d="M10.5645 14.3273C10.492 14.1165 10.4526 13.8902 10.4526 13.6548C10.4526 12.5133 11.378 11.5879 12.5195 11.5879C13.1417 11.5879 13.6996 11.8628 14.0785 12.2977C15.1132 14.383 16.3875 16.8158 17.3554 18.2346C16.125 19.9064 15.8294 20.7502 15.5742 21.4689C14.7929 20.3804 13.1585 18.1644 12.5742 17.4221C12.261 17.0242 11.8789 16.5158 11.4844 16.4143C11.0703 15.6525 10.7696 14.9423 10.5645 14.3273Z"
        fill="url(#paint20_radial_7780_7776)"
      />
      <path
        d="M10.5645 14.3273C10.492 14.1165 10.4526 13.8902 10.4526 13.6548C10.4526 12.5133 11.378 11.5879 12.5195 11.5879C13.1417 11.5879 13.6996 11.8628 14.0785 12.2977C15.1132 14.383 16.3875 16.8158 17.3554 18.2346C16.125 19.9064 15.8294 20.7502 15.5742 21.4689C14.7929 20.3804 13.1585 18.1644 12.5742 17.4221C12.261 17.0242 11.8789 16.5158 11.4844 16.4143C11.0703 15.6525 10.7696 14.9423 10.5645 14.3273Z"
        fill="url(#paint21_radial_7780_7776)"
      />
      <path
        d="M10.5645 14.3273C10.492 14.1165 10.4526 13.8902 10.4526 13.6548C10.4526 12.5133 11.378 11.5879 12.5195 11.5879C13.1417 11.5879 13.6996 11.8628 14.0785 12.2977C15.1132 14.383 16.3875 16.8158 17.3554 18.2346C16.125 19.9064 15.8294 20.7502 15.5742 21.4689C14.7929 20.3804 13.1585 18.1644 12.5742 17.4221C12.261 17.0242 11.8789 16.5158 11.4844 16.4143C11.0703 15.6525 10.7696 14.9423 10.5645 14.3273Z"
        fill="url(#paint22_radial_7780_7776)"
      />
      <path
        d="M10.5645 14.3273C10.492 14.1165 10.4526 13.8902 10.4526 13.6548C10.4526 12.5133 11.378 11.5879 12.5195 11.5879C13.1417 11.5879 13.6996 11.8628 14.0785 12.2977C15.1132 14.383 16.3875 16.8158 17.3554 18.2346C16.125 19.9064 15.8294 20.7502 15.5742 21.4689C14.7929 20.3804 13.1585 18.1644 12.5742 17.4221C12.261 17.0242 11.8789 16.5158 11.4844 16.4143C11.0703 15.6525 10.7696 14.9423 10.5645 14.3273Z"
        fill="url(#paint23_radial_7780_7776)"
      />
      <path
        d="M10.5645 14.3273C10.492 14.1165 10.4526 13.8902 10.4526 13.6548C10.4526 12.5133 11.378 11.5879 12.5195 11.5879C13.1417 11.5879 13.6996 11.8628 14.0785 12.2977C15.1132 14.383 16.3875 16.8158 17.3554 18.2346C16.125 19.9064 15.8294 20.7502 15.5742 21.4689C14.7929 20.3804 13.1585 18.1644 12.5742 17.4221C12.261 17.0242 11.8789 16.5158 11.4844 16.4143C11.0703 15.6525 10.7696 14.9423 10.5645 14.3273Z"
        fill="url(#paint24_radial_7780_7776)"
      />
      <path
        d="M10.5645 14.3273C10.492 14.1165 10.4526 13.8902 10.4526 13.6548C10.4526 12.5133 11.378 11.5879 12.5195 11.5879C13.1417 11.5879 13.6996 11.8628 14.0785 12.2977C15.1132 14.383 16.3875 16.8158 17.3554 18.2346C16.125 19.9064 15.8294 20.7502 15.5742 21.4689C14.7929 20.3804 13.1585 18.1644 12.5742 17.4221C12.261 17.0242 11.8789 16.5158 11.4844 16.4143C11.0703 15.6525 10.7696 14.9423 10.5645 14.3273Z"
        fill="url(#paint25_linear_7780_7776)"
      />
      <path
        d="M13.9936 12.0811C14.8117 13.8382 15.833 16.1021 17.1568 17.9249C17.7662 17.8364 19.2342 17.1562 20.1561 15.6719C19.3259 14.337 17.8995 11.3309 17.0433 8.26091C16.7105 7.56537 16.0002 7.08496 15.1777 7.08496C14.0362 7.08496 13.1108 8.01035 13.1108 9.15186C13.1108 9.2585 13.1189 9.36325 13.1345 9.46555C13.2394 10.1541 13.7574 11.5029 13.9936 12.0811Z"
        fill="url(#paint26_radial_7780_7776)"
      />
      <path
        d="M13.9936 12.0811C14.8117 13.8382 15.833 16.1021 17.1568 17.9249C17.7662 17.8364 19.2342 17.1562 20.1561 15.6719C19.3259 14.337 17.8995 11.3309 17.0433 8.26091C16.7105 7.56537 16.0002 7.08496 15.1777 7.08496C14.0362 7.08496 13.1108 8.01035 13.1108 9.15186C13.1108 9.2585 13.1189 9.36325 13.1345 9.46555C13.2394 10.1541 13.7574 11.5029 13.9936 12.0811Z"
        fill="url(#paint27_radial_7780_7776)"
      />
      <path
        d="M13.9936 12.0811C14.8117 13.8382 15.833 16.1021 17.1568 17.9249C17.7662 17.8364 19.2342 17.1562 20.1561 15.6719C19.3259 14.337 17.8995 11.3309 17.0433 8.26091C16.7105 7.56537 16.0002 7.08496 15.1777 7.08496C14.0362 7.08496 13.1108 8.01035 13.1108 9.15186C13.1108 9.2585 13.1189 9.36325 13.1345 9.46555C13.2394 10.1541 13.7574 11.5029 13.9936 12.0811Z"
        fill="url(#paint28_linear_7780_7776)"
      />
      <path
        d="M13.9936 12.0811C14.8117 13.8382 15.833 16.1021 17.1568 17.9249C17.7662 17.8364 19.2342 17.1562 20.1561 15.6719C19.3259 14.337 17.8995 11.3309 17.0433 8.26091C16.7105 7.56537 16.0002 7.08496 15.1777 7.08496C14.0362 7.08496 13.1108 8.01035 13.1108 9.15186C13.1108 9.2585 13.1189 9.36325 13.1345 9.46555C13.2394 10.1541 13.7574 11.5029 13.9936 12.0811Z"
        fill="url(#paint29_radial_7780_7776)"
      />
      <path
        d="M13.9936 12.0811C14.8117 13.8382 15.833 16.1021 17.1568 17.9249C17.7662 17.8364 19.2342 17.1562 20.1561 15.6719C19.3259 14.337 17.8995 11.3309 17.0433 8.26091C16.7105 7.56537 16.0002 7.08496 15.1777 7.08496C14.0362 7.08496 13.1108 8.01035 13.1108 9.15186C13.1108 9.2585 13.1189 9.36325 13.1345 9.46555C13.2394 10.1541 13.7574 11.5029 13.9936 12.0811Z"
        fill="url(#paint30_radial_7780_7776)"
      />
      <path
        d="M13.9936 12.0811C14.8117 13.8382 15.833 16.1021 17.1568 17.9249C17.7662 17.8364 19.2342 17.1562 20.1561 15.6719C19.3259 14.337 17.8995 11.3309 17.0433 8.26091C16.7105 7.56537 16.0002 7.08496 15.1777 7.08496C14.0362 7.08496 13.1108 8.01035 13.1108 9.15186C13.1108 9.2585 13.1189 9.36325 13.1345 9.46555C13.2394 10.1541 13.7574 11.5029 13.9936 12.0811Z"
        fill="url(#paint31_radial_7780_7776)"
      />
      <path
        d="M13.9936 12.0811C14.8117 13.8382 15.833 16.1021 17.1568 17.9249C17.7662 17.8364 19.2342 17.1562 20.1561 15.6719C19.3259 14.337 17.8995 11.3309 17.0433 8.26091C16.7105 7.56537 16.0002 7.08496 15.1777 7.08496C14.0362 7.08496 13.1108 8.01035 13.1108 9.15186C13.1108 9.2585 13.1189 9.36325 13.1345 9.46555C13.2394 10.1541 13.7574 11.5029 13.9936 12.0811Z"
        fill="url(#paint32_linear_7780_7776)"
      />
      <path
        d="M13.9936 12.0811C14.8117 13.8382 15.833 16.1021 17.1568 17.9249C17.7662 17.8364 19.2342 17.1562 20.1561 15.6719C19.3259 14.337 17.8995 11.3309 17.0433 8.26091C16.7105 7.56537 16.0002 7.08496 15.1777 7.08496C14.0362 7.08496 13.1108 8.01035 13.1108 9.15186C13.1108 9.2585 13.1189 9.36325 13.1345 9.46555C13.2394 10.1541 13.7574 11.5029 13.9936 12.0811Z"
        fill="url(#paint33_radial_7780_7776)"
      />
      <path
        d="M13.9936 12.0811C14.8117 13.8382 15.833 16.1021 17.1568 17.9249C17.7662 17.8364 19.2342 17.1562 20.1561 15.6719C19.3259 14.337 17.8995 11.3309 17.0433 8.26091C16.7105 7.56537 16.0002 7.08496 15.1777 7.08496C14.0362 7.08496 13.1108 8.01035 13.1108 9.15186C13.1108 9.2585 13.1189 9.36325 13.1345 9.46555C13.2394 10.1541 13.7574 11.5029 13.9936 12.0811Z"
        fill="url(#paint34_radial_7780_7776)"
      />
      <path
        d="M11.4784 16.4135C11.2806 16.3506 11.0699 16.3167 10.8513 16.3167C9.70981 16.3167 8.78442 17.242 8.78442 18.3835C8.78442 18.8516 8.94 19.2833 9.20227 19.6298C10.2062 21.1328 11.9013 23.2585 13.8178 25.3164C16.196 24.2024 15.9844 21.9374 15.5789 21.4554C15.571 21.4776 13.5539 18.6662 12.5742 17.4217C12.5582 17.4013 12.5419 17.3807 12.5255 17.3598C12.2218 16.9728 11.8587 16.5103 11.4844 16.4139C11.3404 16.1489 11.3389 16.1417 11.4784 16.4135Z"
        fill="url(#paint35_radial_7780_7776)"
      />
      <path
        d="M11.4784 16.4135C11.2806 16.3506 11.0699 16.3167 10.8513 16.3167C9.70981 16.3167 8.78442 17.242 8.78442 18.3835C8.78442 18.8516 8.94 19.2833 9.20227 19.6298C10.2062 21.1328 11.9013 23.2585 13.8178 25.3164C16.196 24.2024 15.9844 21.9374 15.5789 21.4554C15.571 21.4776 13.5539 18.6662 12.5742 17.4217C12.5582 17.4013 12.5419 17.3807 12.5255 17.3598C12.2218 16.9728 11.8587 16.5103 11.4844 16.4139C11.3404 16.1489 11.3389 16.1417 11.4784 16.4135Z"
        fill="url(#paint36_radial_7780_7776)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.7299 2.36244C19.7475 2.11453 19.9628 1.92786 20.2107 1.94549C21.1825 2.0146 22.4414 2.45045 23.4512 3.37961C24.475 4.32159 25.2256 5.75579 25.1755 7.76884C25.1693 8.01729 24.9629 8.21368 24.7145 8.2075C24.466 8.20131 24.2696 7.99489 24.2758 7.74644C24.3194 5.99386 23.6755 4.80891 22.8419 4.04192C21.9943 3.26209 20.9328 2.89911 20.1469 2.84322C19.899 2.82559 19.7123 2.61034 19.7299 2.36244Z"
        fill="#1B99E7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.7299 2.36244C19.7475 2.11453 19.9628 1.92786 20.2107 1.94549C21.1825 2.0146 22.4414 2.45045 23.4512 3.37961C24.475 4.32159 25.2256 5.75579 25.1755 7.76884C25.1693 8.01729 24.9629 8.21368 24.7145 8.2075C24.466 8.20131 24.2696 7.99489 24.2758 7.74644C24.3194 5.99386 23.6755 4.80891 22.8419 4.04192C21.9943 3.26209 20.9328 2.89911 20.1469 2.84322C19.899 2.82559 19.7123 2.61034 19.7299 2.36244Z"
        fill="url(#paint37_radial_7780_7776)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.7299 2.36244C19.7475 2.11453 19.9628 1.92786 20.2107 1.94549C21.1825 2.0146 22.4414 2.45045 23.4512 3.37961C24.475 4.32159 25.2256 5.75579 25.1755 7.76884C25.1693 8.01729 24.9629 8.21368 24.7145 8.2075C24.466 8.20131 24.2696 7.99489 24.2758 7.74644C24.3194 5.99386 23.6755 4.80891 22.8419 4.04192C21.9943 3.26209 20.9328 2.89911 20.1469 2.84322C19.899 2.82559 19.7123 2.61034 19.7299 2.36244Z"
        fill="url(#paint38_radial_7780_7776)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.5571 3.95741C17.5655 3.70902 17.7736 3.5144 18.0219 3.52272C18.9969 3.55536 20.3511 3.98583 21.4525 4.94861C22.5706 5.92602 23.4178 7.44414 23.3551 9.60659C23.3479 9.85501 23.1407 10.0506 22.8923 10.0434C22.6439 10.0362 22.4483 9.82896 22.4555 9.58053C22.5101 7.6961 21.783 6.43297 20.8601 5.62621C19.9205 4.80481 18.7669 4.44816 17.9918 4.42221C17.7434 4.4139 17.5488 4.2058 17.5571 3.95741Z"
        fill="#1B99E7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.5571 3.95741C17.5655 3.70902 17.7736 3.5144 18.0219 3.52272C18.9969 3.55536 20.3511 3.98583 21.4525 4.94861C22.5706 5.92602 23.4178 7.44414 23.3551 9.60659C23.3479 9.85501 23.1407 10.0506 22.8923 10.0434C22.6439 10.0362 22.4483 9.82896 22.4555 9.58053C22.5101 7.6961 21.783 6.43297 20.8601 5.62621C19.9205 4.80481 18.7669 4.44816 17.9918 4.42221C17.7434 4.4139 17.5488 4.2058 17.5571 3.95741Z"
        fill="url(#paint39_radial_7780_7776)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.5571 3.95741C17.5655 3.70902 17.7736 3.5144 18.0219 3.52272C18.9969 3.55536 20.3511 3.98583 21.4525 4.94861C22.5706 5.92602 23.4178 7.44414 23.3551 9.60659C23.3479 9.85501 23.1407 10.0506 22.8923 10.0434C22.6439 10.0362 22.4483 9.82896 22.4555 9.58053C22.5101 7.6961 21.783 6.43297 20.8601 5.62621C19.9205 4.80481 18.7669 4.44816 17.9918 4.42221C17.7434 4.4139 17.5488 4.2058 17.5571 3.95741Z"
        fill="url(#paint40_radial_7780_7776)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.78139 15.5122C4.02912 15.5322 4.21373 15.7492 4.19374 15.997C4.10166 17.1379 4.3782 18.3349 5.06869 19.3077C5.75391 20.2731 6.86434 21.0432 8.49461 21.3137C8.73979 21.3544 8.90557 21.5861 8.86489 21.8313C8.82421 22.0765 8.59248 22.2423 8.3473 22.2016C6.49321 21.8939 5.16615 21 4.33477 19.8286C3.50866 18.6647 3.1895 17.2524 3.29665 15.9246C3.31665 15.6768 3.53367 15.4922 3.78139 15.5122Z"
        fill="url(#paint41_linear_7780_7776)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.78139 15.5122C4.02912 15.5322 4.21373 15.7492 4.19374 15.997C4.10166 17.1379 4.3782 18.3349 5.06869 19.3077C5.75391 20.2731 6.86434 21.0432 8.49461 21.3137C8.73979 21.3544 8.90557 21.5861 8.86489 21.8313C8.82421 22.0765 8.59248 22.2423 8.3473 22.2016C6.49321 21.8939 5.16615 21 4.33477 19.8286C3.50866 18.6647 3.1895 17.2524 3.29665 15.9246C3.31665 15.6768 3.53367 15.4922 3.78139 15.5122Z"
        fill="url(#paint42_radial_7780_7776)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.87747 17.38C2.12489 17.4035 2.30641 17.6231 2.28292 17.8705C2.07019 20.111 3.54507 22.4004 6.35616 22.7805C6.60245 22.8138 6.77511 23.0404 6.74181 23.2867C6.70851 23.533 6.48186 23.7056 6.23557 23.6723C2.92163 23.2243 1.13088 20.4824 1.38695 17.7854C1.41044 17.538 1.63005 17.3565 1.87747 17.38Z"
        fill="url(#paint43_linear_7780_7776)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.87747 17.38C2.12489 17.4035 2.30641 17.6231 2.28292 17.8705C2.07019 20.111 3.54507 22.4004 6.35616 22.7805C6.60245 22.8138 6.77511 23.0404 6.74181 23.2867C6.70851 23.533 6.48186 23.7056 6.23557 23.6723C2.92163 23.2243 1.13088 20.4824 1.38695 17.7854C1.41044 17.538 1.63005 17.3565 1.87747 17.38Z"
        fill="url(#paint44_radial_7780_7776)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.6494 14.4955) rotate(99.9366) scale(17.1322 19.1258)"
      >
        <stop
          offset="0.561943"
          stop-color="#F2BCAD"
          stop-opacity="0"
        />
        <stop
          offset="0.95539"
          stop-color="#BA7D94"
        />
      </radialGradient>
      <linearGradient
        id="paint1_linear_7780_7776"
        x1="13.363"
        y1="22.5632"
        x2="10.5765"
        y2="25.6681"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#BA7D94"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#BA7D94"
        />
      </linearGradient>
      <radialGradient
        id="paint2_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.2966 20.3615) rotate(86.8399) scale(6.80917 5.01389)"
      >
        <stop stop-color="#FFE2C9" />
        <stop
          offset="1"
          stop-color="#FFE2C9"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint3_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.0793 16.4563) rotate(89.3772) scale(4.06633 2.99422)"
      >
        <stop stop-color="#F9C6B1" />
        <stop
          offset="1"
          stop-color="#F9C6B1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint4_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(26.6869 14.7858) rotate(41.3078) scale(8.48251 8.13211)"
      >
        <stop
          offset="0.217813"
          stop-color="#EDB7A7"
        />
        <stop
          offset="0.41692"
          stop-color="#EDB7A7"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint5_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(29.4285 16.0949) rotate(7.28278) scale(2.04143 5.99757)"
      >
        <stop
          offset="0.125069"
          stop-color="#FFCFB9"
        />
        <stop
          offset="1"
          stop-color="#FEDBC4"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint6_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.5053 22.6116) rotate(-4.19419) scale(9.08553 10.7394)"
      >
        <stop
          offset="0.364432"
          stop-color="#F7C1AF"
        />
        <stop
          offset="0.563201"
          stop-color="#F7C1AF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint7_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.1956 11.124) rotate(137.466) scale(2.36204 2.03216)"
      >
        <stop stop-color="#FFE0C5" />
        <stop
          offset="1"
          stop-color="#FFE1C6"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint8_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.6641 13.4058) rotate(11.4337) scale(2.4979 5.51541)"
      >
        <stop
          offset="0.0622247"
          stop-color="#E9B3A5"
        />
        <stop
          offset="1"
          stop-color="#EAB5A7"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint9_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.9185 12.5601) rotate(10.7843) scale(2.26676 5.20186)"
      >
        <stop
          offset="0.0482326"
          stop-color="#C98C73"
        />
        <stop
          offset="1"
          stop-color="#EEB9A9"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint10_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.7672 19.2007) rotate(55.3334) scale(4.50016 1.68185)"
      >
        <stop
          offset="0.229794"
          stop-color="#FFD6C0"
        />
        <stop
          offset="1"
          stop-color="#FFD1BA"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint11_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-3.74851 1.66603 -3.48499 -7.88246 23.2217 11.2274)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.599845"
          stop-color="#E1A696"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#E1A696"
        />
      </radialGradient>
      <radialGradient
        id="paint12_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-4.62221 2.43483 -6.10282 -11.6422 23.1778 10.9732)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.620251"
          stop-color="#EAB1A0"
          stop-opacity="0"
        />
        <stop
          offset="0.915696"
          stop-color="#B55B4B"
        />
      </radialGradient>
      <radialGradient
        id="paint13_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(21.9058 11.5723) rotate(67.7035) scale(6.85802 1.43993)"
      >
        <stop stop-color="#FFE0C7" />
        <stop
          offset="0.899756"
          stop-color="#FDCCB7"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint14_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.0397 7.74548) rotate(75.999) scale(5.36609 3.33328)"
      >
        <stop
          offset="0.34375"
          stop-color="#FFE0C7"
        />
        <stop
          offset="0.899756"
          stop-color="#FFE0C7"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint15_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.5077 14.8595) rotate(-127.591) scale(3.72686 0.797122)"
      >
        <stop stop-color="#C8947A" />
        <stop
          offset="1"
          stop-color="#C8947A"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint16_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(1.42613 2.10525 -2.68335 1.70829 18.273 5.29666)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E3B79C" />
        <stop
          offset="1"
          stop-color="#E3B79C"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint17_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.8893 15.582) rotate(59.5344) scale(0.508384 1.04899)"
      >
        <stop stop-color="#E4AD9B" />
        <stop
          offset="1"
          stop-color="#E4AD9B"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint18_linear_7780_7776"
        x1="20.5171"
        y1="15.7214"
        x2="20.7805"
        y2="14.2031"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F5BFAE" />
        <stop
          offset="1"
          stop-color="#F5BFAE"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint19_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.9688 15.6096) rotate(146.452) scale(3.50589 9.38314)"
      >
        <stop
          offset="0.425307"
          stop-color="#E2A693"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#E2A693"
        />
      </radialGradient>
      <radialGradient
        id="paint20_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.9688 15.6096) rotate(147.829) scale(4.57788 12.2522)"
      >
        <stop
          offset="0.624797"
          stop-color="#E09E7E"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#E09E7E"
        />
      </radialGradient>
      <radialGradient
        id="paint21_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.6649 17.4935) rotate(-32.6806) scale(3.93552 24.9102)"
      >
        <stop
          offset="0.692182"
          stop-color="#B55B4B"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#B55B4B"
        />
      </radialGradient>
      <radialGradient
        id="paint22_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.2068 15.0452) rotate(61.8712) scale(6.67853 1.41437)"
      >
        <stop stop-color="#FFD3BF" />
        <stop
          offset="1"
          stop-color="#FFD3BF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint23_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0.275562 2.28609 -2.70493 0.28401 12.7406 11.2183)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAAA90" />
        <stop
          offset="1"
          stop-color="#DAAA90"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint24_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.0664 19.2803) rotate(56.6503) scale(4.3943 1.46962)"
      >
        <stop
          offset="0.0997061"
          stop-color="#B55B4B"
        />
        <stop
          offset="1"
          stop-color="#B55B4B"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint25_linear_7780_7776"
        x1="16.555"
        y1="19.336"
        x2="15.0938"
        y2="18.4533"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F5BFAE" />
        <stop
          offset="1"
          stop-color="#F5BFAE"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint26_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.9402 12.4878) rotate(149.999) scale(4.32353 10.2337)"
      >
        <stop
          offset="0.655467"
          stop-color="#E2A085"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#E2A085"
        />
      </radialGradient>
      <radialGradient
        id="paint27_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.8309 12.4878) rotate(155.961) scale(1.67667 10.6108)"
      >
        <stop stop-color="#E1A086" />
        <stop
          offset="1"
          stop-color="#E1A086"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint28_linear_7780_7776"
        x1="17.6561"
        y1="17.9687"
        x2="16.7967"
        y2="15.3281"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F5BFAE" />
        <stop
          offset="1"
          stop-color="#F5BFAE"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint29_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.446 6.68083) rotate(83.5812) scale(2.51577 2.77818)"
      >
        <stop stop-color="#DDAD92" />
        <stop
          offset="1"
          stop-color="#DDAD92"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint30_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.1549 11.248) rotate(67.3923) scale(9.234 1.50582)"
      >
        <stop
          offset="0.239583"
          stop-color="#FED4B6"
        />
        <stop
          offset="1"
          stop-color="#FCCBB7"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint31_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.0522 11.6746) rotate(154.738) scale(1.36347 5.16751)"
      >
        <stop
          offset="0.280096"
          stop-color="#B55B4B"
        />
        <stop
          offset="1"
          stop-color="#B55B4B"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint32_linear_7780_7776"
        x1="18.9163"
        y1="17.5792"
        x2="17.6856"
        y2="16.284"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.357193"
          stop-color="#F5BFAE"
        />
        <stop
          offset="0.6405"
          stop-color="#F5BFAE"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint33_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(1.61311 -0.69093 2.94462 6.93793 14.8022 14.3569)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.092806"
          stop-color="#B55B4B"
        />
        <stop
          offset="1"
          stop-color="#E8B19A"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint34_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-0.0244557 -0.917077 3.93909 -0.0920436 17.3897 17.8614)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.092806"
          stop-color="#F5BFAE"
        />
        <stop
          offset="1"
          stop-color="#F5BFAE"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint35_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.2713 18.2909) rotate(132.32) scale(1.65614 5.61524)"
      >
        <stop
          offset="0.211062"
          stop-color="#B55B4B"
        />
        <stop
          offset="1"
          stop-color="#B55B4B"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint36_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0.281307 2.1063 -2.76133 0.261675 11.12 15.8719)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DCA990" />
        <stop
          offset="1"
          stop-color="#DCA990"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint37_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.2102 5.2342) rotate(-44.7092) scale(2.17659 5.56896)"
      >
        <stop stop-color="#16579C" />
        <stop
          offset="0.743739"
          stop-color="#16579C"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint38_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(2.74767 3.2674 -2.15292 1.91392 21.4707 6.0682)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.667349"
          stop-color="#154F8C"
        />
        <stop
          offset="1"
          stop-color="#154F8C"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint39_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(1.66671 -1.60486 4.2213 4.14803 20.1956 6.94882)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#16579C" />
        <stop
          offset="0.861756"
          stop-color="#16579C"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint40_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.3278 7.86241) rotate(48.1522) scale(4.54407 3.07549)"
      >
        <stop
          offset="0.75121"
          stop-color="#154F8C"
        />
        <stop
          offset="1"
          stop-color="#154F8C"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint41_linear_7780_7776"
        x1="4.83517"
        y1="15.9608"
        x2="8.02267"
        y2="22.5936"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1679C5" />
        <stop
          offset="1"
          stop-color="#0D5194"
        />
      </linearGradient>
      <radialGradient
        id="paint42_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.53829 18.578) rotate(164.814) scale(2.26665 6.09358)"
      >
        <stop
          offset="0.705955"
          stop-color="#0E5196"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#0E5196"
        />
      </radialGradient>
      <linearGradient
        id="paint43_linear_7780_7776"
        x1="2.87145"
        y1="17.828"
        x2="6.61299"
        y2="25.9484"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.297941"
          stop-color="#1679C5"
        />
        <stop
          offset="1"
          stop-color="#0D5194"
        />
      </linearGradient>
      <radialGradient
        id="paint44_radial_7780_7776"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-2.08906 0.552939 -1.52438 -5.4766 3.54293 20.2653)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.705955"
          stop-color="#0E5196"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#0E5196"
        />
      </radialGradient>
      <clipPath id="clip0_7780_7776">
        <rect
          width="32"
          height="32"
          fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
